/*
 * 统一管理从服务端获取的数据，方便后期维护
 * 通过export  暴露封装的获取数据方法
 */
import Axios from "axios";

const industryAnalyze = process.env.VUE_APP_SERVER_URL

//获取全部行业
export const industriesApi = (data) => Axios.get(industryAnalyze + '/dict/industry/industries', data);

//获取北京地区
export const districtsApi = (data) => Axios.get(industryAnalyze + '/dict/district/districts', data);

//获取全部国家
export const counterVyContinentIdApi = (data) => Axios.get(industryAnalyze + '/dict/country/countries', data);

// 提交保存时
export const addEntInfoApi = (data) => Axios.post(industryAnalyze + '/ent/saveInfo', data);

// 修改保存时
export const modifyInfoInfoApi = (data) => Axios.put(industryAnalyze + '/ent/modifyInfo', data);
